import { render, staticRenderFns } from "./MultiHome.vue?vue&type=template&id=43066360&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MultiHome.vue"
export default component.exports